import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		backgroundColor: 'blue',
		currentKey: false,
		endRound: false,
		endGame: false,
		difficulty: 0,
		gamemode: false,
		isPreCounting: false,
		soundsStatus: false,
		dictionaryRaw: false,
		dictionary: false,
		//text: 'Questa è la storia di come la mia vita sia cambiata, capovolta, sottosopra sia finita. Questa è la storia di come la mia vita sia cambiata, capovolta, sottosopra sia finita. Questa è la storia di come la mia vita sia cambiata, capovolta, sottosopra sia finita. Questa è la storia di come la mia vita sia cambiata, capovolta, sottosopra sia finita. Questa è la storia di come la mia vita sia cambiata, capovolta, sottosopra sia finita. Questa è la storia di come la mia vita sia cambiata, capovolta, sottosopra sia finita. Questa è la storia di come la mia vita sia cambiata, capovolta, sottosopra sia finita. Questa è la storia di come la mia vita sia cambiata, capovolta, sottosopra sia finita. Questa è la storia di come la mia vita sia cambiata, capovolta, sottosopra sia finita. Questa è la storia di come la mia vita sia cambiata, capovolta, sottosopra sia finita. Questa è la storia di come la mia vita sia cambiata, capovolta, sottosopra sia finita. ',
		text: '',
		words: {
			subject_1: {
				is: [[],[]],
				says: [[],[]],
				does: [[],[]]
			},
			subject_2: {
				is: [[],[]],
				says: [[],[]],
				does: [[],[]]
			},
			context: {
				place: [[],[]],
				time: [[],[]]
			},
			expressions: {
				expressions: [[],[]]
			}
		},
		words_extended: {
			subject_1: {
				is: [[],[]],
				says: [[],[]],
				does: [[],[]]
			},
			subject_2: {
				is: [[],[]],
				says: [[],[]],
				does: [[],[]]
			},
			context: {
				place: [[],[]],
				time: [[],[]]
			},
			expressions: {
				expressions: [[],[]]
			}
		},
		foundWords: {
			subject_1: {
				is: [false,false],
				says: [false,false],
				does: [false,false]
			},
			subject_2: {
				is: [false,false],
				says: [false,false],
				does: [false,false]
			},
			context: {
				place: [false,false],
				time: [false,false]
			},
			expressions: {
				expressions: [false,false]
			}
		},
		foundCards: {
			subject_1: false,
			subject_2: false,
			context: false,
			expressions: false
		},
		updatedCard: false,
		currentSelection: false,
		currentSelectionCaret: 0
	},
	mutations: {
		updateProperty(state, { property, value }) {
			state[property] = value;
		},
		updateFoundWord(state, { property, value }) {
			//state.foundWords[property.card][property.wordGroup][property.index] = value;
			Vue.set(state.foundWords[property.card][property.wordGroup], property.index, value);
		},
		updateFoundCard(state, { property, value }) {
			//state.foundWords[property.card][property.wordGroup][property.index] = value;
			Vue.set(state.foundCards, property, value);
		}
	},
	actions: {
		updateProperty(context, { property, value }) {
			context.commit('updateProperty', { property, value });
		}
	},
	modules: {
	}
})
